module.exports = __webpack_public_path__ + "static/media/bg-take-prize-mobile.f49cbcb6.png";